// What kind of file a name / URL points to, from its extension. Pure (no React), imported by its own path rather than `shared/utils`,
// whose index pulls in the whole app.

export const FILE_EXTENSIONS = {
  pdf: ['pdf'],
  document: ['doc', 'docx', 'dot', 'dotx', 'odt', 'rtf'],
  spreadsheet: ['xls', 'xlsx', 'xlsm', 'csv', 'tsv', 'ods'],
  presentation: ['ppt', 'pptx', 'pps', 'ppsx', 'odp', 'key'],
  image: ['jpg', 'jpeg', 'jfif', 'png', 'gif', 'bmp', 'tif', 'tiff', 'webp', 'svg', 'heic', 'ico'],
  video: ['mp4', 'webm', 'mov', 'avi', 'mkv', 'm4v', 'wmv', 'flv', '3gp'],
  audio: ['mp3', 'wav', 'ogg', 'ogm', 'm4a', 'aac', 'flac', 'wma'],
}

// the extension of a file name or URL, lower case, without a query string or hash ('' when there is none)
export const extensionOf = (name) => {
  const base = String(name || '').split(/[?#]/)[0].split('/').pop()
  return base.includes('.') ? base.split('.').pop().toLowerCase() : ''
}

// 'pdf' | 'document' | 'spreadsheet' | 'presentation' | 'image' | 'video' | 'audio' | 'other'. The file name is read first, then the
// URL (a name without an extension can still sit behind a URL that has one).
export const fileKind = (name, url) => {
  const extensions = [extensionOf(name), extensionOf(url)].filter(Boolean)
  const kinds = Object.keys(FILE_EXTENSIONS)
  for (const extension of extensions) {
    const kind = kinds.find(k => FILE_EXTENSIONS[k].includes(extension))
    if (kind) return kind
  }
  return 'other'
}

// The files of a media field's value as `{ name, url }`, for a list or a table cell: the value as the issue list returns it, a list
// of media objects, a single one, or entries wrapped as `{ value: media, relation_data }` (a field that tracks revisions).
// The name is the file name, else the media's title, else the last part of its URL; entries with no file are skipped.
export const fileEntries = (value) => (Array.isArray(value) ? value : [value])
  .map(raw => (raw && typeof raw === 'object' && raw.value && typeof raw.value === 'object' ? raw.value : raw))
  .filter(media => media && typeof media === 'object' && (media.file_name || media.image_url))
  .map(media => ({
    name: media.file_name || media.title || String(media.image_url).split(/[?#]/)[0].split('/').pop(),
    url: media.image_url,
  }))
